export default __webpack_public_path__ + "static/media/mody-vision.d3a4126b.png";